export const HIDE_COMPANY_EMAIL_PIPELINE_STAGE_ID = "1555994847";

export const shouldHideCompanyInEmail = (pipelineStage?: string | null) => {
  if (typeof pipelineStage !== "string") {
    return false;
  }
  return pipelineStage.trim() === HIDE_COMPANY_EMAIL_PIPELINE_STAGE_ID;
};

